import { LeftIcon, RightIcon } from '@/icons';
import { RadioChangeEvent } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledButton,
  StyledButtons,
  StyledPageSizeWrapper,
  StyledPagination,
  StyledRadioGroup,
} from './PaginationStyles';
import { IPagination, IPaginationDTO } from '@/models/pagination.model';

type TPaginationProps = {
  loading?: boolean;
  onChange?: (pagination: IPaginationDTO) => void;
  limitOptions?: number[];
  cursor?: IPagination;
};

const defaultLimitOptions = [30, 50, 70, 100];

const Pagination = ({ onChange, cursor, limitOptions = defaultLimitOptions, loading }: TPaginationProps) => {
  const { t } = useTranslation('common');

  const handlePageSizeChange = (e: RadioChangeEvent) => {
    onChange?.({
      cursor: undefined,
      limit: e.target.value,
    });
  };

  const handlePageChange = useCallback(
    (page?: string) => {
      onChange?.({
        cursor: page,
        limit: cursor?.limit,
      });
    },
    [cursor?.limit, onChange],
  );

  return (
    <StyledPagination>
      {cursor?.limit && (
        <StyledPageSizeWrapper>
          <span>{t('pagination_items_per_page')}</span>
          <StyledRadioGroup
            buttonStyle="solid"
            optionType="button"
            disabled={loading}
            size="large"
            options={limitOptions}
            value={cursor?.limit}
            onChange={handlePageSizeChange}
          />
        </StyledPageSizeWrapper>
      )}
      {(cursor?.next || cursor?.prev) && (
        <StyledButtons>
          <StyledButton
            disabled={!cursor?.prev || loading}
            icon={<LeftIcon />}
            onClick={() => handlePageChange(cursor?.prev ?? undefined)}
          />
          <StyledButton
            disabled={!cursor?.next || loading}
            icon={<RightIcon />}
            onClick={() => handlePageChange(cursor?.next ?? undefined)}
          />
        </StyledButtons>
      )}
    </StyledPagination>
  );
};

export default Pagination;
